import { useTranslation } from "react-i18next";

const PassportCannotIssued = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-6 py-6">
      <div className="flex gap-4 items-center">
        <div className="h-8 w-8 min-w-8 rounded-full border-2 border-primary-blue font-bold text-primary-blue flex justify-center items-center">
          1
        </div>
        <p>
          {t(
            "instructions.instructions_list.passport_cannot_issued.content.step1"
          )}
        </p>
      </div>
      <div className="flex gap-4 items-center">
        <div className="h-8 w-8 min-w-8 rounded-full border-2 border-primary-blue font-bold text-primary-blue flex justify-center items-center">
          2
        </div>
        <p>
          {t(
            "instructions.instructions_list.passport_cannot_issued.content.step2"
          )}
        </p>
      </div>
      <div className="flex gap-4 items-center">
        <div className="h-8 w-8 min-w-8 rounded-full border-2 border-primary-blue font-bold text-primary-blue flex justify-center items-center">
          3
        </div>
        <p>
          {t(
            "instructions.instructions_list.passport_cannot_issued.content.step3"
          )}
        </p>
      </div>
      <div className="flex gap-4 items-center">
        <div className="h-8 w-8 min-w-8 rounded-full border-2 border-primary-blue font-bold text-primary-blue flex justify-center items-center">
          4
        </div>
        <p>
          {t(
            "instructions.instructions_list.passport_cannot_issued.content.step4"
          )}
        </p>
      </div>
    </div>
  );
};

export default PassportCannotIssued;
